export const environment = {
  production: false,
  appcode: 'ITRecovery',
  serviceBaseUrl: 'https://initrecovery-uat.ey.net/ITRecoveryAPI/api',
  tokenPath: 'https://initrecovery-uat.ey.net/ITRecoveryAPI/api/Token',
  logoutUrl: 'https://initrecovery-uat.ey.net/#/logout',
  sessionExpireUrl: 'https://initrecovery-uat.ey.net/#/sessionexpired',
  pageAnalyticsUrl: 'https://inpageanalytics.ey.net/Pages/InsertPageAnalytic.aspx',
  RecordSize: 10,
  msalConfig: {
    auth: {
      authURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/authorize',
      tokenURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/token',
      clientId: 'a6d9bc83-30b2-4df9-81a9-2072e6f1f50e',
      authority: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c'
    }
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'http://graph.microsoft.com/v1.0/me'
  },
  isHostingAzure: true,
  instrumentationKey: 'b5a3470b-8c32-45b3-8250-dd5d5ffddbcb',
  PostLogoutRedirectUri: 'https://initrecovery-uat.ey.net/#/logout',
  RedirectUri: 'https://initrecovery-uat.ey.net',
  logPageAnalytics: 'N',
};
import 'zone.js/plugins/zone-error';

// export const environment = {
//   production: false,
//   appcode: 'ITRecovery',
//   serviceBaseUrl: 'http://localhost:8593/api/',
//   tokenPath: 'http://localhost:8593/api/Token',
//   logoutUrl: 'http://localhost:4200/logout',
//   sessionExpireUrl: 'http://localhost:4200/sessionexpired',
//   pageAnalyticsUrl: 'https://inpageanalytics.ey.net/Pages/InsertPageAnalytic.aspx',
//   RecordSize: 10,
//   msalConfig: {
//     auth: {
//       authURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/authorize',
//       tokenURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/token',
//       clientId: 'a6d9bc83-30b2-4df9-81a9-2072e6f1f50e',
//       authority: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c'
//     }
//   },
//   apiConfig: {
//     scopes: ['user.read'],
//     uri: 'http://graph.microsoft.com/v1.0/me'
//   },
//   isHostingAzure: true,
//   instrumentationKey: 'b5a3470b-8c32-45b3-8250-dd5d5ffddbcb',
//   PostLogoutRedirectUri: 'http://localhost:4200/logout',
//   RedirectUri: 'http://localhost:4200/',
//   logPageAnalytics: 'N',
// };
// import 'zone.js/plugins/zone-error';
